import { companyProfileSchema } from './company-profile';

import type { CompanyProfile } from './company-profile';
import type { ValidatingHttpFetcherWithBaseUrl } from '../../../shared/source/validating-http-fetcher';
import type Result from 'true-myth/result';

export type FetchCompanyProfile = () => Promise<Result<CompanyProfile, unknown>>;

export const createFetchCompanyProfile = (dependencies: {
    readonly validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl;
}): FetchCompanyProfile => {
    const { validatingCobrainerApiFetcher } = dependencies;

    return () => {
        return validatingCobrainerApiFetcher.get(companyProfileSchema, {
            pathname: `/company-profile`,
        });
    };
};
